export interface IAnalyticsConfiguration {
	providers: IAnalyticsProvidersConfiguration;
}

export interface IAnalyticsProvidersConfiguration {
	[key: string]: any;
}

export interface IAnalyticsEvent {
	[key: string]: any;
}

export enum EAnalyticsProvider {
	GTM = 'GTM',
	ALGOLIA = 'Algolia'
}
